import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { PageContainer, PageHeader } from "@/components/layout/page";
import { AnomaliesPanel } from "@/components/monitoring/anomalies-panel";
import { UsagePanel } from "@/components/monitoring/usage-panel";
import { AuditPanel } from "@/components/monitoring/audit-panel";

const TABS = ["anomalies", "usage", "audit"] as const;
type TabKey = (typeof TABS)[number];

export const Route = createFileRoute("/_app/monitoring")({
  validateSearch: z.object({
    tab: z.enum(TABS).catch("anomalies"),
  }),
  component: MonitoringPage,
});

function MonitoringPage() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const active: TabKey = tab ?? "anomalies";

  return (
    <PageContainer>
      <PageHeader title="Monitoring" description="Anomalies, usage, and the audit trail." />
      <Tabs
        value={active}
        onChange={(_, v: TabKey) => navigate({ search: { tab: v } })}
        sx={{ mb: 3 }}
      >
        <Tab value="anomalies" label="Anomalies" />
        <Tab value="usage" label="Usage" />
        <Tab value="audit" label="Audit Log" />
      </Tabs>

      {active === "anomalies" ? <AnomaliesPanel /> : null}
      {active === "usage" ? <UsagePanel /> : null}
      {active === "audit" ? <AuditPanel /> : null}
    </PageContainer>
  );
}
